<!-- Spacer -->
<div class="expepharma-horizontal-navigation-item-wrapper" [ngClass]="item.classes?.wrapper"></div>
